export const VisaRequestsTypesEnum = {
  Allocation: {
    key: 1,
  },
  ConfirmAllocation: {
    key: 2,
  },
  Reservation: {
    key: 3,
  },
  ConfirmReservation: {
    key: 4,
  },
  EditAllocation: {
    key: 5,
  },
  EditReservation: {
    key: 6,
  },
  ViewAllocation: {
    key: 7,
  },
  ViewReservation: {
    key: 8,
  },
};
